/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Daily_RateInputs */

const fr_validation_daily_rate = /** @type {(inputs: Validation_Daily_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un TJM supérieur à zéro, avec 6 décimales maximum.`)
};

const en_validation_daily_rate = /** @type {(inputs: Validation_Daily_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a daily rate greater than zero, with at most 6 decimals.`)
};

/**
* | output |
* | --- |
* | "Enter a daily rate greater than zero, with at most 6 decimals." |
*
* @param {Validation_Daily_RateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_daily_rate = /** @type {((inputs?: Validation_Daily_RateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Daily_RateInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_daily_rate(inputs)
	return fr_validation_daily_rate(inputs)
});